import Cookies from 'js-cookie'

interface CreateCookiesProps {
  name: string
  value: string
  expirationHours?: number
}

interface CookieStatus {
  isValid: boolean
  value: string | null
  expirationDate: Date | null
}

export const setCookies = ({ name, value, expirationHours = 2 }: CreateCookiesProps) => {
  const expirationDate = new Date()
  expirationDate.setHours(expirationDate.getHours() + expirationHours)

  Cookies.set(name, JSON.stringify({ value: value, expiration: expirationDate }), { expires: expirationHours / 24 })
}

export const getCookies = (name: string): CookieStatus => {
  const cookie = Cookies.get(name)

  if (!cookie) {
    return {
      isValid: false,
      value: null,
      expirationDate: null
    }
  }
  const cookieData = JSON.parse(cookie)
  const expirationDate = new Date(cookieData.expiration)
  const value = cookieData.value

  return {
    isValid: true,
    value: value,
    expirationDate: expirationDate
  }
}

export const validateCookies = (name: string): number => {
  const { expirationDate } = getCookies(name)
  const now = new Date()

  if (!expirationDate) {
    return 0
  }

  return expirationDate.getTime() - now.getTime()
}

export const removeCookies = (name: string): void => {
  Cookies.remove(name)
}

export const isSmartfitClient = (): boolean => {
  const { value } = getCookies('client')
  return value === 'smartfitnutri'
}
